import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageDetail, LandingPagePublicationState } from '../../models/cms-models';

@Component({
  selector: 'cms-publication-settings',
  imports: [CommonModule, FormsModule],
  templateUrl: './publication-settings.html',
  styleUrl: './publication-settings.css',
})
export class PublicationSettingsComponent {
  @Input({ required: true }) landingPage!: LandingPageDetail;
  @Input() hideHeader = false;
  @Output() landingPageChange = new EventEmitter<LandingPageDetail>();

  readonly states: LandingPagePublicationState[] = ['Draft', 'Published', 'Scheduled'];

  updateState(state: LandingPagePublicationState): void {
    this.landingPageChange.emit({
      ...this.landingPage,
      publicationState: state,
      scheduledPublishAt: state === 'Scheduled' ? this.landingPage.scheduledPublishAt : null,
    });
  }

  updateScheduledPublishAt(localValue: string): void {
    this.landingPageChange.emit({
      ...this.landingPage,
      scheduledPublishAt: localValue ? new Date(localValue).toISOString() : null,
    });
  }

  toLocalValue(): string {
    if (!this.landingPage.scheduledPublishAt) {
      return '';
    }

    const date = new Date(this.landingPage.scheduledPublishAt);
    const pad = (value: number) => value.toString().padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }
}
